// import React, { Suspense } from "react"
import FormCK, { TinyFormCK, useEmailForm } from "./FormCK"

export { TinyFormCK, useEmailForm }

// const LazyForm = React.lazy(() => import("./FormCK"))

// export default (props) => (
//   <Suspense fallback={<div>Loading ...</div>}>
//     <LazyForm {...props} />
//   </Suspense>
// )

export default FormCK
